import type {
  RepaymentTypeOption,
  RatePlanRepaymentVM,
  RatePlanVM,
} from "@/models/loanConfiguration";
import { useStore } from "vuex";

export function loanConfigurationActions() {
  const store = useStore();

  function setLoading(flag: boolean) {
    store.dispatch("loanConfigurationModule/setLoading", flag);
  }

  function setSavingChanges(flag: boolean) {
    store.dispatch("loanConfigurationModule/setSavingChanges", flag);
  }

  function setSelectedRepaymentOption(
    selectedRepaymentType?: RatePlanRepaymentVM | RepaymentTypeOption,
  ) {
    store.dispatch("loanConfigurationModule/setSelectedRepaymentOption", selectedRepaymentType);
  }

  function setSelectedRatePlan(appRatePlan?: RatePlanVM) {
    store.dispatch("loanConfigurationModule/setSelectedRatePlan", appRatePlan);
  }

  function setSelectedRateTypeId(ratePlanId: number) {
    store.dispatch("loanConfigurationModule/setSelectedRateTypeId", ratePlanId);
  }

  return {
    setLoading,
    setSavingChanges,
    setSelectedRepaymentOption,
    setSelectedRatePlan,
    setSelectedRateTypeId,
  };
}
